<template>
  <AssayDescriptionGrid :dv="dv" :fields="fields" />
  <ImagingDimension
    v-model:z-stack="zStack"
    v-model:time-lapse="timeLapse"
    :dv="dv"
    :validation-errors="validationErrors"
  />
</template>

<script>
import { useAssayVuelidate } from '@/composables/validation/assay/useAssayValidation'
import {
  useImagingDimensionValidation,
  useChannelsValidation,
} from '@/composables/validation/assay/useImagingValidation'
import AssayDescriptionGrid from '../shared/AssayDescriptionGrid.vue'
import { CUSTOM_PROPERTIES } from '../../shared/fieldConstants.js'
import ImagingDimension from './ImagingDimension.vue'

const fields = [
  ['name'],
  ['id'],
  ['state', 'slot:fc:is_template'],
  ['imaging_method'],
  ['widget:instrumentData'],
  ['objective'],
  ['slot:fc:run_dir'],
  ['datasessions'],
  ['description'],
  CUSTOM_PROPERTIES,
  ['protocol_list'],
]

export default {
  name: 'AssayLightMicroscopy',
  components: {
    AssayDescriptionGrid,
    ImagingDimension,
  },
  props: {
    dv: { type: Object, required: true },
  },
  setup(props) {
    const { zStack, timeLapse, zPlanesError, timePointsError } =
      useImagingDimensionValidation(props.dv)
    const { channelsError } = useChannelsValidation(props.dv)

    const { validationErrors } = useAssayVuelidate({
      z_planes: zPlanesError,
      time_points: timePointsError,
      channels: channelsError,
    })

    return {
      fields,
      validationErrors,
      zStack,
      timeLapse,
    }
  },
}
</script>
